/* eslint-disable react/prop-types */
import React from 'react';

import { buildUserRecordHref } from '../../../utils/userRecord';

/**
 * 看得见活动 · 会员明细列定义
 * ------------------------------------------------------------------
 * 列定义外置（重构方案 §4.3）。
 *
 * 「已体验」列是**受控服务端排序**：列上给 `sorter: true` + `sortOrder`，
 * 比较函数不写（服务端才算得对，本地只能排当页）；点击表头后由
 * DataTable 的 `onChange` 回写 sort 参数重新请求。
 */
export const visibleActivityColumns = (sort) => [
  { title: '参与会员', dataIndex: 'nickName' },
  {
    title: '奖励总次数',
    dataIndex: 'totalRewardNum',
    width: 130,
    numeric: true,
    unit: '次',
  },
  {
    title: '当前可体验',
    dataIndex: 'canExpNum',
    width: 130,
    numeric: true,
    unit: '次',
  },
  {
    title: '已体验',
    dataIndex: 'expedNum',
    width: 130,
    numeric: true,
    unit: '次',
    /* 受控排序：排序由服务端算，不写比较函数 */
    sorter: true,
    sortOrder: sort === 0 ? 'descend' : 'ascend',
  },
  {
    title: '操作',
    key: 'operation',
    width: 100,
    render: (_, record) => {
      const href = buildUserRecordHref(record && record.userId);
      return href ? (
        <a href={href} target="_blank" rel="noreferrer">
          查看详情
        </a>
      ) : (
        '--'
      );
    },
  },
];
